import ModalActionsWrapper from './ModalActionsWrapper'
export default ModalActionsWrapper